import { faFilter, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormProvider, useForm } from "react-hook-form";
import MultSelect from "../../../../Components/CardsPages/Forms/MultSelect";
import UnForm from "../../../../Components/Form";
import StickyToolbar from "../../../../Components/StickyToolbar";
import { ListarEmpreendimentosComObraController } from "../../../../Controllers/Geral/Produtos/ProdutosControllers";
import {
    ListarAnalistasDeCreditoController,
} from "../../../../Controllers/Vendas/AnaliseDeCredito/AnaliseDeCreditoControllers";
import { ListarEquipesDeVendasController } from "../../../../Controllers/Vendas/EquipeVendas/EquipeVendasControllers";
import { IAnalisesDeCreditoBody } from "../../../../Interfaces/Vendas/GestaoAtendimentos/AnaliseDeCredito/AnaliseDeCreditoInterfaces";
import StorageManagerCapys from "../../../../Tools/Storage";

interface IAnaliseDeCreditoFiltroProps {
    handleSubmit: (filter: IAnalisesDeCreditoBody) => void;
    defaultFilter?: IAnalisesDeCreditoBody;
    storageManager: StorageManagerCapys<IAnalisesDeCreditoBody>;
}

export default function AnaliseDeCreditoFiltro(
    props: IAnaliseDeCreditoFiltroProps
) {
    const filter = props.defaultFilter;
    const hadleFilterFormSubmit = props.handleSubmit;
    const FormMethods = useForm();
    const { reset, control } = FormMethods;

    return (
        <StickyToolbar active={Boolean(filter)}>
            <FormProvider {...FormMethods}>
                <UnForm handleSubmit={hadleFilterFormSubmit} usingContext>
                    <div className="col-12 mt-3">
                        <UnForm.Select name="DS_STATUS" label="Status">
                            <option></option>
                            <option value="NÃO INICIADA">Não Iniciado</option>
                            <option value="EM ANÁLISE">Em Análise</option>
                            <option value="PENDÊNCIA">Pendência</option>
                            <option value="APROVADA">Aprovada</option>
                            <option value="REPROVADA">Reprovada</option>
                        </UnForm.Select>
                    </div>

                    {/* {
                        <div className="col-12 mt-3">
                            <label>ID do Caso</label>
                            <UnForm.Input
                                className="form-control"
                                name="ID_CASO"
                                defaultValue={filter?.ID_CASO}
                            />
                            
                        </div>
                    } */}

                    <div className="col-12 mt-3">
                        <label>Produto</label>
                        <MultSelect
                            control={control}
                            name="ID_PRODUTOS"
                            // defaultValue={filter.ID_GRUPO}
                            controller={ListarEmpreendimentosComObraController}
                            getDS={(e) => e.DS_EMPREENDIMENTO}
                            getKeyValue={(e) => e.ID_EMPREENDIMENTO}
                            virtual={true}
                            showSearch={false}
                        >
                            <option></option>
                        </MultSelect>
                    </div>

                    <div className="col-12 mt-3">
                        <label>Analista</label>
                        <UnForm.LazySelect
                            className="form-control"
                            name="ID_USUARIO_RESPONSAVEL"
                            defaultValue={filter?.ID_USUARIO_RESPONSAVEL}
                            registerOptions={{
                                valueAsNumber: true,
                            }}
                            controller={ListarAnalistasDeCreditoController}
                            getDS={(u) => u.DS_NOME}
                            getKeyValue={(u) => u.ID_USUARIO}
                            {...FormMethods}
                        >
                            <option value={0}></option>
                        </UnForm.LazySelect>
                    </div>
                    {/* <div className="col-12 mt-3">
                        <label>Protocolo</label>
                        <UnForm.Input
                            className="form-control"
                            type="number"
                            defaultValue={filter?.ID_CASO}
                            name="ID_CASO"
                            registerOptions={{
                                valueAsNumber: true,
                            }}
                        />
                    </div> */}
                    <div className="col-12 mt-3">
                        <UnForm.Select
                            className="form-control"
                            defaultValue={filter?.FL_VENDA}
                            name="FL_VENDA"
                            label="Virou Venda?"
                        >
                            <option defaultValue={2}></option>
                            <option value={1}>Sim</option>
                            <option value={0}>Não</option>
                        </UnForm.Select>
                    </div>
                    <div className="col-12 mt-3">
                        <label>Desistiu?</label>
                        <UnForm.Select
                            className="form-control"
                            defaultValue={filter?.FL_DESISTENCIA}
                            name="FL_DESISTENCIA"
                        >
                            <option defaultValue={2}></option>
                            <option value={0}>Sim</option>
                            <option value={1}>Não</option>
                        </UnForm.Select>
                    </div>
                    <div className="col-12 mt-3">
                        <label>Equipes Vendas</label>
                        <MultSelect
                            control={control}
                            name="EQUIPES_VENDA"
                            // defaultValue={filter.ID_GRUPO}
                            controller={ListarEquipesDeVendasController}
                            getDS={(e) => e.DS_EQUIPE_VENDAS}
                            getKeyValue={(e) => e.ID_EQUIPE_VENDAS}
                            virtual={true}
                            showSearch={false}
                        >
                            <option></option>
                        </MultSelect>
                    </div>
                    <div className="col-12 col-md-12 d-flex align-items-end justify-content-start mt-3">
                        <button
                            type="submit"
                            className="btn btn-block btn-outline-dark"
                        >
                            <FontAwesomeIcon icon={faFilter} className="mr-2" />
                            Filtrar
                        </button>
                    </div>
                    <div className="col-12 d-flex align-items-end justify-content-start">
                        <button
                            type="button"
                            onClick={() => {
                                window.sessionStorage.removeItem(
                                    "FILTRO_GESTAO_ANALISE_CREDITO"
                                );
                                reset(props.defaultFilter);
                            }}
                            className="btn btn-block btn-outline-danger mt-2"
                        >
                            <FontAwesomeIcon icon={faTimes} className="mr-2" />
                            Limpar Filtros
                        </button>
                    </div>
                </UnForm>
            </FormProvider>
        </StickyToolbar>
    );
}
